import { Component, OnInit } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class ErrorComponent implements OnInit {
    // #region [props]
    refCode: string;
    // #endregion

    constructor() {
        this.refCode = btoa((new Date()).toISOString());
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
